import { useEffect, useRef, useState } from 'react';
import { useSelector, useStore } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../store';
import { getIsTeamRally, getLocationFilter, getSelectTargetGroupId, getSelectThemeId, selectRalliesStatus, setRallies, setRalliesLoadFailed, setRalliesLoading, } from '../../store/slices/ralliesPreview';
import { selectIsOnline } from '../../store/slices/global';
import { getRallies } from '../../api/game-mode/rallies';
/**
 * Loads the public rally list whenever filters or the language change,
 * and loads it again when the connection comes back after a failed load.
 */
export const useRalliesLoader = () => {
    const dispatch = useAppDispatch();
    // read the status without subscribing, so App does not re-render on every status change
    const store = useStore();
    const { i18n } = useTranslation();
    const selectedThemeId = useSelector(getSelectThemeId);
    const selectedTargetGroupId = useSelector(getSelectTargetGroupId);
    const locationFilter = useSelector(getLocationFilter);
    const isTeamRally = useSelector(getIsTeamRally);
    const isOnline = useSelector(selectIsOnline);
    const [reloadCount, setReloadCount] = useState(0);
    const latestRequestIdRef = useRef(0);
    const wasOnlineRef = useRef(isOnline);
    useEffect(() => {
        const requestId = ++latestRequestIdRef.current;
        const fetchRallies = async () => {
            dispatch(setRalliesLoading());
            const result = await getRallies({
                'themes[]': selectedThemeId,
                locationFilter,
                'targetGroups[]': selectedTargetGroupId,
                isTeamRally,
            });
            // a newer request was started in the meantime, its response wins
            if (requestId !== latestRequestIdRef.current) {
                return;
            }
            if (result.ok) {
                dispatch(setRallies(result.rallies));
            }
            else {
                dispatch(setRalliesLoadFailed());
            }
        };
        fetchRallies();
    }, [
        dispatch,
        selectedThemeId,
        selectedTargetGroupId,
        locationFilter,
        isTeamRally,
        i18n.language,
        reloadCount,
    ]);
    useEffect(() => {
        const isBackOnline = isOnline && !wasOnlineRef.current;
        wasOnlineRef.current = isOnline;
        if (isBackOnline && selectRalliesStatus(store.getState()) === 'error') {
            setReloadCount((count) => count + 1);
        }
    }, [isOnline, store]);
};
